<!-- 铁路到站量趋势分析表 -->
<template>
  <div>
    <el-card style="margin-bottom: 20px;">
      <div class="title" style="margin-bottom: 10px;">
        <p></p>
        <div>
          <el-date-picker v-model="value" type="daterange" align="right" unlink-panels range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
          </el-date-picker>
          <el-select v-model="value1" placeholder="选择物资" style="width: 160px;margin-left: 16px;">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-button type="primary" icon="el-icon-search" style="margin-left: 16px;width: 98px;">搜索</el-button>
          <el-button icon="el-icon-refresh-left" style="margin-left: 16px;width: 98px;">重置</el-button>
        </div>
      </div>
    </el-card>
    <matrix-statistics span="8" :list="statisticsList"></matrix-statistics>
    <el-card style="margin-top: 20px">
      <div class="title" style="margin-bottom: 10px;">
        <p>到站趋势分析</p>
      </div>
      <div id="forecast"></div>
    </el-card>
    <el-card style="margin-top: 20px">
      <div class="title" style="margin-bottom: 10px;">
        <p>物资结构分析</p>
      </div>
      <div id="bar"></div>
    </el-card>
    <div style="height: 80px;"></div>
  </div>
</template>

<script>
import matrixStatistics from '@/components/matrix/matrix-statistics'
import { getDefaultSearchTimeRange, getSearchTimePickerOptions } from '@/basic-common/util/common'
import * as echarts from 'echarts';
export default {
  name: "store-management/index/index",
  components: {
    matrixStatistics,
  },
  data() {
    return {
      value: getDefaultSearchTimeRange('daterange'),
      pickerOptions: getSearchTimePickerOptions('daterange'),
      value1: '',
      options: [{
        value: '选项1',
        label: '黄金糕'
      }, {
        value: '选项2',
        label: '双皮奶'
      }, {
        value: '选项3',
        label: '蚵仔煎'
      }, {
        value: '选项4',
        label: '龙须面'
      }, {
        value: '选项5',
        label: '北京烤鸭'
      }],
      statisticsList: [{
        label: '区间内到站车次',
        value: 286,
      }, {
        label: '区间内到货总量（吨）',
        value: 28650,
      }, {
        label: '区间内日均到货量（吨）',
        value: 1432,
      }],
    }
  },
  mounted() {
    this.forecastInit()
    this.barInit()
  },
  methods: {
    forecastInit() {
      let chartDom = document.getElementById('forecast');
      let myChart = echarts.init(chartDom);
      let option = {
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        legend: {
          textStyle: {
            color: '#374151',
            fontSize: 14,
          },
          lineStyle: {
            type: 'solid'
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
          splitLine: {
            lineStyle: {
              color: '#e0e6f1'
            }
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
        },
        yAxis: [
          {
            type: 'value',
            name: '到站车次',
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              lineStyle: {
                color: '#e0e6f1'
              }
            }
          }, {
            type: 'value',
            name: '到货总量',
            position: 'right',
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              lineStyle: {
                color: '#e0e6f1'
              }
            }
          }
        ],
        series: [
          {
            name: '到站车次',
            data: [8120, 3932, 11041, 12345, 12940, 13310, 13230, 11011, 12324, 12910, 15330, 13320],
            type: 'line',
            smooth: true,
            lineStyle: {
              color: '#2563EB',
              width: 2,
            },
            itemStyle: {
              color: '#2563EB',
            },
          },
          {
            name: '到货总量',
            data: [820, 932, 1101, 1234, 1290, 1330, 1320, 1101, 1234, 1290, 1330, 1320],
            type: 'line',
            smooth: true,
            yAxisIndex: 1,
            lineStyle: {
              color: '#10b981',
              width: 2,
            },
            itemStyle: {
              color: '#10b981',
            },
          },
        ]
      };
      option && myChart.setOption(option);
    },
    barInit() {
      let chartDom = document.getElementById('bar');
      let myChart = echarts.init(chartDom);

      const rawData = [
        [100, 302, 301, 334, 390, 330, 320,101, 134, 90, 230, 210],
        [320, 132, 101, 134, 90, 230, 210,201, 154, 190, 330, 410,],
        [220, 182, 191, 234, 290, 330, 310, 901, 934, 1290, 1330, 1320],
        [150, 212, 201, 154, 190, 330, 410, 191, 234, 290, 330, 310],
      ];
      const totalData = [];
      for (let i = 0; i < rawData[0].length; ++i) {
        let sum = 0;
        for (let j = 0; j < rawData.length; ++j) {
          sum += rawData[j][i];
        }
        totalData.push(sum);
      }
      const series = [
        '无烟煤',
        '烟煤',
        '褐煤',
        '其他',
      ].map((name, sid) => {
        return {
          name,
          type: 'bar',
          stack: 'total',
          barWidth: '60%',
          label: {
            show: true,
            formatter: (params) => Math.round(params.value)  + '%'
          },
          data: rawData[sid].map((d, did) =>
            totalData[did] <= 0 ? 0 : (d / totalData[did]) * 100
          )
        };
      });
      console.log(series)

      let option = {
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        legend: {
          show: true,
        },
        xAxis: {
          type: 'category',
          data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
          splitLine: {
            lineStyle: {
              color: '#e0e6f1'
            }
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          max: 100,
          splitLine: {
            lineStyle: {
              color: '#e0e6f1'
            }
          },
          axisLabel:{
            formatter: (params)=> params + '%'
          }
        },
        series: series
      };
      option && myChart.setOption(option);
    }
  }
}
</script>
<style scoped lang="scss">
#forecast,
#bar {
  width: 100%;
  height: 400px;
}

.title {
  display: flex;
  align-items: center;
  justify-content: space-between;

  p {
    color: #000000;
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    margin: 0;
  }
}

::v-deep .el-input__icon {
  line-height: 1 !important;
}
</style>
